import { sortSubwayLines } from './sort.js';
/**
 * Merge platform rows into one row per station complex, nearest first.
 *
 * Shared by the visible "Nearby transit" section and the unit page's JSON-LD
 * so the two cannot disagree: markup that claims a station the page does not
 * show is a structured-data content mismatch, which is the exact failure we
 * already carry on the building page's review markup.
 */
export function groupNearbyTransit(raw) {
    const byName = new Map();
    for (const station of raw) {
        const existing = byName.get(station.name);
        if (!existing) {
            byName.set(station.name, {
                key: station.stationId,
                name: station.name,
                lines: [...station.lines],
                distanceMi: station.distanceMi,
            });
            continue;
        }
        for (const line of station.lines) {
            if (!existing.lines.includes(line))
                existing.lines.push(line);
        }
        if (station.distanceMi < existing.distanceMi) {
            existing.distanceMi = station.distanceMi;
        }
    }
    return Array.from(byName.values())
        .map(station => ({ ...station, lines: sortSubwayLines(station.lines) }))
        .sort((a, b) => a.distanceMi - b.distanceMi);
}
/**
 * One station rendered as a sentence, mirroring the visible row.
 *
 * The section shows line bullets, then "at <name>", then the distance; this
 * is the same three facts in the same order, for consumers that read text
 * rather than DOM — `"N, Q, R at 86 St — 0.3 mi"`.
 */
export function formatNearbyTransit(station) {
    return `${station.lines.join(', ')} at ${station.name} — ${station.distanceMi} mi`;
}
